import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectMetaData } from "../store/selectors.js";

const getLanguagePrefix = (lang) => {
    switch (lang) {
        case 'ru':
            return 'ru_';
        case 'hy':
            return 'arm_';
        case 'en':
        default:
            return 'en_';
    }
};

const AppHelmet = () => {
    const { i18n } = useTranslation();
    const prefix = useMemo(() => getLanguagePrefix(i18n.language), [i18n.language]);
    const meta = useSelector(selectMetaData);

    if (!meta) return null;

    const {
        [`${prefix}title`]: title,
        [`${prefix}description`]: description,
        [`${prefix}keywords`]: keywords,
        image,
    } = meta || {};

    const pageUrl = typeof window !== 'undefined' ? window.location.href : '';

    return (
        <Helmet>
            <title>{title || 'Somnium.am'}</title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}

            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            {image && <meta property="og:image" content={image} />}
            {pageUrl && <meta property="og:url" content={pageUrl} />}
            <meta property="og:type" content="website" />

            <meta name="twitter:card" content="summary_large_image" />
            {title && <meta name="twitter:title" content={title} />}
            {description && <meta name="twitter:description" content={description} />}
            {image && <meta name="twitter:image" content={image} />}
            {pageUrl && <meta name="twitter:url" content={pageUrl} />}
        </Helmet>
    );
};

export default AppHelmet;
